export const webAddress = "https://victorgaodev.com/";
